export enum TableSortOrder{
  Ascending = 1,
  Descending = -1
}
